<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Banner About Us</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Edit Banner About Us</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Name"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.name"
              name="name"
              data-vv-as="Name"
              id="input-1"
              class="form-control"
              placeholder="Name"
            />
            <b-form-invalid-feedback id="input-name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="input-group-1" label="Banner Image (Desktop):" label-for="input-1">
            <!-- <input
              v-model="items.image_desktop_webp"
              v-validate="'required'"
              name="image_desktop_webp"
              data-vv-as="Url Image Desktop WebP"
              placeholder="Url Image Desktop WebP"
              class="form-control"
            />
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('image_desktop_webp') }}</p> -->
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Desktop)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(1920px x 700px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileDesktop"
                    name="imagedesktop"
                    v-validate="'image|minimalDimensions:1920,700|ratiolDimensions:96,35|size:2000|ext:jpg,png,gif,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFileDesktop()"
                  />
                  <b-button
                    @click="$refs.fileDesktop.click()"
                    v-show="!items.image_desktop && !fileDesktop"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_desktop || fileDesktop"
                    variant="primary"
                    @click="modalDesktop = !modalDesktop"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileDesktop.click()"
                    v-show="items.image_desktop || fileDesktop"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imagedesktop') }}</p>
        </b-col>
        <b-col md="6">
          <b-form-group id="input-group-1" label="Banner Image (Mobile):" label-for="input-1">
            <!-- <input
              v-model="items.image_mobile_webp"
              v-validate="'required'"
              name="image_mobile_webp"
              data-vv-as="Url Image Mobile WebP"
              placeholder="Url Image Mobile WebP"
              class="form-control"
            />
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('image_mobile_webp') }}</p> -->
          </b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Banner Image (Mobile)</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(640px x 600px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileMobile"
                    name="imagemobile"
                    v-validate="'image|minimalDimensions:640,600|ratiolDimensions:64,60|size:2000|ext:jpg,png,gif,jpeg'"
                    style="display: none"
                    v-on:change="onChangeFileMobile()"
                  />
                  <b-button
                    @click="$refs.fileMobile.click()"
                    v-show="!items.image_mobile && !fileMobile"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="items.image_mobile || fileMobile"
                    variant="primary"
                    @click="modalMobile = !modalMobile"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.fileMobile.click()"
                    v-show="items.image_mobile || fileMobile"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('imagemobile') }}</p>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Banner Image Alt Text (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.image_alt.id"
              name="title_id"
              data-vv-as="Banner Image Alt Text (Bahasa)"
              id="input-1"
              class="form-control"
              placeholder="Banner Image Alt Text (Bahasa)"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Banner Image Alt Text (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.image_alt.en"
              name="title_en"
              data-vv-as="Banner Image Alt Text (English)"
              class="form-control"
              placeholder="Banner Image Alt Text (English)"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.heading.id"
              name="title_id"
              data-vv-as="Heading Bahasa"
              id="input-1"
              class="form-control"
              placeholder="Heading In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.heading.en"
              name="title_en"
              data-vv-as="Heading English"
              class="form-control"
              placeholder="Heading In English"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <textarea
              placeholder="Sub Heading in Bahasa"
              v-model="items.sub_heading.id"
              data-vv-as="Sub Heading Bahasa"
              v-validate="'required'"
              name="content_id"
              class="form-control"
            ></textarea>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('content_id') }}</p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <textarea
              placeholder="Sub Heading in English"
              v-model="items.sub_heading.en"
              v-validate="'required'"
              name="content_en"
              data-vv-as="Sub Heading English"
              class="form-control"
            ></textarea>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('content_en') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">
            Save
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalMobile" title="Preview Image" size="xl">
      <img
        v-show="!fileMobile"
        v-if="items.image_mobile"
        width
        height="400px"
        :src="items.image_mobile"
      />
      <img v-show="fileMobile" v-if="urlMobile" width height="400px" :src="urlMobile" />
    </b-modal>
    <b-modal v-model="modalDesktop" title="Preview Image" size="xl">
      <img
        v-show="!fileDesktop"
        v-if="items.image_desktop"
        width
        height="400px"
        :src="items.image_desktop"
      />
      <img v-show="fileDesktop" v-if="urlDesktop" width height="400px" :src="urlDesktop" />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      widthImage: null,
      heightImage: null,
      loading: false,
      items: [],
      urlImage: "",
      modalImage: false,
      image: "",
      modalMobile: false,
      modalDesktop: false,
      fileDesktop: "",
      fileMobile: "",
      urlMobile: "",
      urlDesktop: ""
    };
  },
  beforeCreate() {
    this.$store.dispatch("BannerAboutusModule/getAboutUsBanner");
  },
  created() {
    this.$store.watch(
      state => state.BannerAboutusModule.aboutus_banner,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this About Us Banner!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("name", this.items.name);
              formData.append("heading_id", this.items.heading.id);
              formData.append("heading_en", this.items.heading.en);
              formData.append("sub_heading_id", this.items.sub_heading.id);
              formData.append("sub_heading_en", this.items.sub_heading.en);
              formData.append("image_alt_id", this.items.image_alt.id);
              formData.append("image_alt_en", this.items.image_alt.en);
              formData.append("image_desktop", this.fileDesktop);
              formData.append("image_mobile", this.fileMobile);
              this.$store
                .dispatch("BannerAboutusModule/postAboutUsBanner", formData)
                .then(response => {
                  this.loading = false;
                  this.$validator.reset();
                  this.$router.push({ name: "editBannerAboutUs" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal("ERROR!", "Your file cant be submit.", "warning");
            }
          });
        }
      });
    },
    onChangeFileDesktop() {
      this.fileDesktop = this.$refs.fileDesktop.files[0];
      const input = this.$refs.fileDesktop;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlDesktop = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobile() {
      this.fileMobile = this.$refs.fileMobile.files[0];
      const input = this.$refs.fileMobile;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlMobile = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>